module.exports = __webpack_public_path__ + "static/media/IMG_20191204_133143.349960a8.jpg";